(() => {
  // Cart: show the COD steps only when cash on delivery is selected.
  document.querySelectorAll('[data-ff-pay-choice]').forEach((group) => {
    const steps = group.querySelector('[data-ff-cod-steps]');
    const sync = () => {
      const picked = group.querySelector('input[type="radio"]:checked');
      const isCod = picked && picked.value === 'Cash on delivery';
      if (steps) steps.hidden = !isCod;
      // Save the choice right away so it survives page reloads.
      if (picked && window.routes) {
        fetch(`${window.routes.cart_update_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Payment preference': picked.value } }),
        }).catch(() => {});
      }
    };
    group.addEventListener('change', sync);
  });

  // COD confirmation: prefill from links like ?order=%231001&contact=me@example.com
  const params = new URLSearchParams(window.location.search);
  document.querySelectorAll('[data-ff-prefill]').forEach((input) => {
    const key = input.dataset.ffPrefill;
    const value = params.get(key) || (key === 'contact' ? params.get('email') || params.get('phone') : null);
    if (value) input.value = value;
  });
  // Arriving from the thank-you page: the order is already identified, so skip the contact field.
  if (params.get('id')) {
    document.querySelectorAll('[data-ff-contact-field]').forEach((field) => {
      const input = field.querySelector('input');
      if (input) { input.required = false; input.removeAttribute('name'); }
      field.hidden = true;
    });
  }

  // COD confirmation: pay the delivery charges on their own, never mixed with other cart items.
  document.querySelectorAll('[data-ff-cod-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (form.dataset.ffReady) return;
      event.preventDefault();
      const order = form.querySelector('[name="properties[Order number]"]');
      if (order && /^\d+$/.test(order.value.trim())) order.value = `#${order.value.trim()}`;
      const button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-busy', 'true');
      fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .catch(() => {})
        .finally(() => {
          form.dataset.ffReady = 'true';
          form.submit();
        });
    });
  });

  // Header: close open menus/search when clicking elsewhere or pressing Escape.
  const closeAll = (target) =>
    document.querySelectorAll('.ff-header details[open]').forEach((d) => {
      if (!target || !d.contains(target)) d.removeAttribute('open');
    });
  document.addEventListener('click', (event) => closeAll(event.target));
  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') closeAll(null);
  });
  document.querySelectorAll('.ff-mobile-menu').forEach((menu) => {
    menu.addEventListener('toggle', () => document.body.classList.toggle('ff-menu-open', menu.open));
  });
})();

// Legal pages: build the "On this page" table of contents from the headings.
(() => {
  const body = document.querySelector('[data-ff-legal-body]');
  const toc = document.querySelector('[data-ff-toc]');
  if (!body || !toc) return;
  const headings = body.querySelectorAll('h2');
  if (headings.length < 3) return;
  const list = toc.querySelector('ol');
  const links = [];
  headings.forEach((h, i) => {
    if (!h.id) h.id = `section-${i + 1}`;
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${h.id}`;
    a.textContent = h.textContent.replace(/^\d+\.\s*/, '');
    li.appendChild(a);
    list.appendChild(li);
    links.push(a);
  });
  toc.hidden = false;
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((l) => l.classList.toggle('is-active', l.hash === `#${entry.target.id}`));
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    headings.forEach((h) => observer.observe(h));
  }
})();

// First-order welcome popup: homepage only (rendered there), once per visit.
(() => {
  const popup = document.querySelector('[data-ff-promo]');
  if (!popup) return;
  const KEY = 'ff-welcome-popup-seen';
  const inEditor = popup.dataset.design === 'true';
  let seen = false;
  try { seen = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
  if (seen && !inEditor) return;

  let lastFocus = null;
  const close = () => {
    popup.hidden = true;
    document.body.classList.remove('ff-promo-open');
    if (lastFocus) lastFocus.focus();
  };
  const open = () => {
    lastFocus = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('ff-promo-open');
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    const btn = popup.querySelector('.ff-promo__close');
    if (btn) btn.focus();
  };
  popup.querySelectorAll('[data-ff-promo-close]').forEach((el) => el.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !popup.hidden) close(); });

  const copyBtn = popup.querySelector('[data-ff-promo-copy]');
  const code = popup.querySelector('[data-ff-promo-code]');
  if (copyBtn && code) {
    copyBtn.addEventListener('click', () => {
      const done = () => {
        const label = copyBtn.textContent;
        copyBtn.textContent = copyBtn.dataset.copied;
        copyBtn.classList.add('is-copied');
        setTimeout(() => { copyBtn.textContent = label; copyBtn.classList.remove('is-copied'); }, 2000);
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code.textContent.trim()).then(done).catch(done);
      } else {
        const r = document.createRange(); r.selectNodeContents(code);
        const s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
        try { document.execCommand('copy'); } catch (e) {}
        done();
      }
    });
  }
  setTimeout(open, inEditor ? 300 : parseInt(popup.dataset.delay || '4000', 10));
})();

// ff-delivery refresh: keep the cart's delivery/COD summary in sync when quantities change.
(() => {
  const footer = document.getElementById('main-cart-footer');
  if (!footer || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    fetch(`${window.location.pathname}?section_id=${footer.dataset.id}`)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-ff-delivery]', '[data-ff-pay-choice]'].forEach((sel) => {
          const fresh = doc.querySelector(sel);
          const current = document.querySelector(sel);
          if (fresh && current) current.replaceWith(fresh);
        });
        const group = document.querySelector('[data-ff-pay-choice]');
        if (group) {
          const steps = group.querySelector('[data-ff-cod-steps]');
          group.addEventListener('change', () => {
            const picked = group.querySelector('input:checked');
            if (steps) steps.hidden = !(picked && picked.value === 'Cash on delivery');
          });
        }
      })
      .catch(() => {});
  });
})();

// COD confirmation page: forward thank-you-page visitors to Safepay, and show payment results.
(() => {
  const card = document.querySelector('[data-ff-cod-pay]');
  if (!card) return;
  const params = new URLSearchParams(window.location.search);
  const status = params.get('status');
  const order = params.get('order') || '';
  if (status) {
    const box = card.querySelector('[data-ff-cod-status]');
    const msg = box && box.querySelector(`[data-status="${status}"]`);
    if (msg) {
      box.querySelectorAll('[data-status]').forEach((el) => { el.hidden = el !== msg; });
      msg.querySelectorAll('[data-ff-order]').forEach((el) => { el.textContent = order; });
      box.hidden = false;
      const done = ['paid', 'already', 'fullpaid', 'alreadypaid'];
      box.dataset.tone = done.includes(status) ? 'ok' : ['pending', 'cancelled'].includes(status) ? 'info' : 'error';
      if (done.includes(status)) card.querySelectorAll('h2, .ff-cod-orders, .ff-cod-confirm__or, [data-ff-cod-manual]').forEach((el) => { el.hidden = true; });
      // The intro explains cash on delivery; it doesn't apply to orders paid in full online.
      if (['fullpaid', 'alreadypaid'].includes(status)) document.querySelectorAll('[data-ff-cod-intro]').forEach((el) => { el.hidden = true; });
    }
    return;
  }
  const id = params.get('id');
  if (id) {
    const notice = card.querySelector('[data-ff-cod-redirect]');
    if (notice) notice.hidden = false;
    const target = new URL(card.dataset.ffCodPay);
    target.searchParams.set('id', id);
    if (order) target.searchParams.set('order', order);
    window.location.replace(target.toString());
    // If Safepay hasn't opened after 20s, bring the manual form back so the customer isn't stuck.
    setTimeout(() => {
      const section = card.closest('.ff-cod-confirm');
      if (section) section.classList.remove('is-redirecting');
      if (notice) notice.hidden = true;
    }, 20000);
  }
})();
